import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-900 border-t border-brand-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold text-brand-50 mb-4">Pabs</div>
            <p className="text-sm text-brand-500 max-w-md">
              Living strategy for living products. Pabs orchestrates your product vision across your
              entire stack, giving you the clarity to think and the confidence to decide.
            </p>
          </div>

          <div>
            <ul className="space-y-3">
              <li>
                <Link to="/platform" className="text-sm text-brand-500 hover:text-brand-50 transition-colors">
                  Platform
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-brand-500 hover:text-brand-50 transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/docs/create-your-first-plan" className="text-sm text-brand-500 hover:text-brand-50 transition-colors">
                  Docs
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-brand-500 hover:text-brand-50 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-brand-500 hover:text-brand-50 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-brand-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-brand-600">© {currentYear} Pabs. All rights reserved.</p>

          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="text-xs text-brand-600 hover:text-brand-50 transition-colors uppercase tracking-wider"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-xs text-brand-600 hover:text-brand-50 transition-colors uppercase tracking-wider"
            >
              Terms of Use
            </Link>
            <Link
              to="/eula"
              className="text-xs text-brand-600 hover:text-brand-50 transition-colors uppercase tracking-wider"
            >
              EULA
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
